/**
 * Klient for oppsettet av en familie (Plan 11; per familie fra FF-11, #179).
 *
 * Systemadminen oppretter familien og den første adminen; adminen velger
 * passord via invitasjonen, logger inn med familiekoden og fullfører
 * oppsettet her med sin egen økt (cookie). Det finnes ikke lenger noe
 * oppsett-token (`ADMIN_BOOTSTRAP_TOKEN` er pensjonert).
 */
import type { ColorSlot, OnboardingMemberInput, OnboardingProfileInput, OnboardingStatus } from '@stell/shared';

export class OnboardingApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: Record<string, unknown>,
  ) {
    super(`onboarding_error_${status}`);
    this.name = 'OnboardingApiError';
  }
}

async function call<T>(path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method: body === undefined ? 'GET' : 'POST',
    credentials: 'same-origin',
    ...(body === undefined
      ? {}
      : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }),
  });
  if (!res.ok) {
    let parsed: Record<string, unknown> = {};
    try {
      parsed = await res.json();
    } catch {
      /* body not JSON */
    }
    throw new OnboardingApiError(res.status, parsed);
  }
  return res.json() as Promise<T>;
}

export type CreateMemberResult = { memberId: string; colorSlot: ColorSlot };

export const OnboardingApi = {
  status: () => call<OnboardingStatus>('/api/onboarding/status'),
  saveProfile: (body: OnboardingProfileInput) => call<{ ok: true }>('/api/onboarding/me', body),
  createMember: (body: OnboardingMemberInput) => call<CreateMemberResult>('/api/onboarding/member', body),
  finish: () => call<{ ok: true }>('/api/onboarding/finish', {}),
};
